import React from "react";
import './Settingslist.css';
import Breadcrumb from '../../Layout/Breadcrumb/Breadcrumb';
import Header from '../../Layout/Header/Header';
import Footer from '../../Layout/Footer/Footer';
import Nav from '../../Layout/Nav/Nav';
// import LoginImage from '../../../Images/login.jpg';

function Masterdatalist()
{
    return(
      <div className="page-con">
              <div className="page-nav">
              <Nav/>
              </div>

              <div className="page-body">
              <Header/>
<Breadcrumb/>


<h1 style={{width:"100%", textAlign:"center"}}>
  Settings Page
</h1>

  
    <Footer/>
              </div>     
      </div>
    );
}
export default Masterdatalist;